import {
  CommonNotificationType,
  INotificationBaseMessage,
  NotificationType,
} from "@evennt-tech/api-v2-core";
import { apiV2 } from "api/firebase";

export type ProductChangePayload = {
  supplierCompanyId?: string;
  showId?: string;
};

export const PRODUCT_CHANGE_KEYS = [
  NotificationType.UPSERTED_PRODUCT,
  NotificationType.DELETED_PRODUCT,
  NotificationType.ASSIGN_PRODUCT_TO_SHOW,
  NotificationType.REMOVE_PRODUCT_FROM_SHOW,
];

export const PRODUCT_CATALOGUE_CHANGE_KEYS = [
  NotificationType.UPSERTED_PRODUCT,
  NotificationType.DELETED_PRODUCT,
];

export const matchesProductChange = (
  payload: ProductChangePayload,
  scope: ProductChangePayload
): boolean => {
  if (
    payload.supplierCompanyId &&
    scope.supplierCompanyId &&
    payload.supplierCompanyId !== scope.supplierCompanyId
  ) {
    return false;
  }

  return !(payload.showId && scope.showId && payload.showId !== scope.showId);
};

export const subscribeToProductChanges = ({
  keys = PRODUCT_CHANGE_KEYS,
  listenerIdPrefix,
  callback,
}: {
  keys?: (NotificationType | CommonNotificationType)[];
  listenerIdPrefix: string;
  callback: (payload: ProductChangePayload) => void;
}): void => {
  for (const key of keys) {
    apiV2.notification.subscribe<
      INotificationBaseMessage<ProductChangePayload>
    >({
      key,
      listenerId: `${listenerIdPrefix}_${key}`,
      callback: ({ payload }) => callback(payload ?? {}),
    });
  }
};
